/**
 * Copyright (c) Microsoft. All rights reserved.
 */
export const noop = () => { };
export const noopEmptyObject = () => ({});
export const noopUndefined = () => undefined;
